module.exports = __webpack_public_path__ + "img/pingtai.3ccbc7fd.png";